import React from 'react';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about">
      <div className="about__hero">
        <div className="about__logo">🧾</div>
        <h1 className="about__title">ДелиЧек</h1>
        <p className="about__subtitle">Разделить счёт — проще простого</p>
      </div>

      <div className="about__card">
        <p className="about__intro">
          Я помогу тебе разделить счёт между друзьями!
        </p>

        <div className="about__steps">
          <div className="about__step">
            <div className="about__step-icon">📸</div>
            <div className="about__step-text">
              <strong>Загрузи фото чека</strong>
              <span>Просто сфоткай — и всё</span>
            </div>
          </div>

          <div className="about__step-divider" />

          <div className="about__step">
            <div className="about__step-icon">🤖</div>
            <div className="about__step-text">
              <strong>Распознаю позиции</strong>
              <span>ИИ автоматически найдёт все блюда и цены</span>
            </div>
          </div>

          <div className="about__step-divider" />

          <div className="about__step">
            <div className="about__step-icon">🎯</div>
            <div className="about__step-text">
              <strong>Создам доску</strong>
              <span>Удобная доска для выбора позиций</span>
            </div>
          </div>

          <div className="about__step-divider" />

          <div className="about__step">
            <div className="about__step-icon">👥</div>
            <div className="about__step-text">
              <strong>Отправь друзьям</strong>
              <span>Каждый отметит свой заказ — и готово!</span>
            </div>
          </div>
        </div>
      </div>

      <div className="about__card about__card--warning">
        <div className="about__warning-icon">⚡</div>
        <p className="about__warning-text">
          <strong>Важный момент:</strong> проект пока держится на моём энтузиазме 
          и лимитах API. Если вдруг бот «устанет» и перестанет отвечать — 
          значит, вы слишком активно кушали! 🍕
        </p>
      </div>

      <div className="about__card about__card--author">
        <p className="about__author-label">Разработчик</p>
        <a 
          href="https://t.me/alekseyKonyashin" 
          target="_blank" 
          rel="noopener noreferrer"
          className="about__author-link"
        >
          <div className="about__author-avatar">👨‍💻</div>
          <div>
            <strong>Aleksey Konyashin</strong>
            <span>Идеи и баг-репорты приветствуются!</span>
          </div>
        </a>
      </div>

      <p className="about__version">v1.0 • VK Mini App</p>
    </div>
  );
};

export default AboutPage;
